import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative flex items-center justify-center py-12 px-6 overflow-hidden bg-cream" data-id="element-92">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-93">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="order-2 lg:order-1 space-y-5" data-id="element-94">
          <div className="space-y-3" data-id="element-95">
            <span className="inline-block px-3 py-1 border border-terracotta/30 text-terracotta text-sm font-medium tracking-wider rounded-full uppercase" data-id="element-96">
              Para cuidadores
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-navy leading-tight" data-id="element-97">
              Cómo cuidar a tus padres{' '}
              <span className="text-terracotta italic" data-id="element-98">sin desaparecer</span> en
              el intento.
            </h1>
          </div>

          <div className="space-y-3 text-lg text-navy/80 leading-relaxed font-light" data-id="element-99">
            <p data-id="element-100">Hay un tipo de cansancio que no se quita durmiendo.</p>
            <p data-id="element-101">
              Es el cansancio de vivir con una antena prendida 24/7: ¿ya comió?
              ¿ya tomó la medicina? ¿y si se cae? ¿y si se enoja? ¿y si hoy toca
              cita? ¿y si nadie más aparece?
            </p>
            <p data-id="element-102">Y lo peor no es solo lo que haces. Es lo que no puedes decir.</p>
            <p data-id="element-103">
              Porque si dices "ya no puedo", te sientes mala persona. Si pides
              ayuda, te minimizan. Y si pones límites, te conviertes en "el/la
              egoísta" de la historia.
            </p>
            <p className="font-medium text-navy" data-id="element-104">
              Este libro existe para ese momento exacto: cuando todo recae sobre
              ti… y por dentro ya estás empezando a quebrarte.
            </p>
          </div>

          <div className="pt-2" data-id="element-105">
            <a href="#comprar" className="inline-flex items-center justify-center px-8 py-4 bg-terracotta text-cream text-lg font-medium rounded-lg hover:bg-terracotta/90 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200" data-id="element-106">
              Quiero el Mapa de Alivio
            </a>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="order-1 lg:order-2 flex justify-center relative" data-id="element-107">
          <div className="relative w-full max-w-md aspect-[3/4] rounded-2xl shadow-2xl overflow-hidden bg-navy/5" data-id="element-108">
            <img src="https://cdn.magicpatterns.com/uploads/ofULURPzh8Qh9mHXzYVhsR/Mockup_Cuidado_de_Padres_Envejecidos.png" alt="Portada del libro Cuando Todo Recae Sobre Ti" className="w-full h-full object-cover object-center transform hover:scale-105 transition-transform duration-700" data-id="element-109" />
            {/* Decorative elements */}
            <div className="absolute -z-10 top-10 -right-10 w-64 h-64 bg-terracotta/10 rounded-full blur-3xl" data-id="element-110"></div>
            <div className="absolute -z-10 -bottom-10 -left-10 w-64 h-64 bg-sage/20 rounded-full blur-3xl" data-id="element-111"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}